import styled from 'styled-components';
import { fontSize, fontStyle, fontWeight, lineHeight, space, textAlign, width } from 'styled-system';
import { Typography } from 'antd';
import { colors } from '../../styles/settings';

const { Text } = Typography;
const Title = styled(Text)`
  color: ${colors.grayLight} !important;
  font-size: 0.875rem;
  ${fontSize};
  ${fontWeight};
  ${fontStyle};
  font-weight: bold;
  line-height: 2.25rem;
  ${lineHeight};
  ${space};
  ${textAlign};
  text-transform: uppercase;
  ${width};
`;

export default Title;
